import React, { Component } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Button, Navbar, NavbarBrand, Nav, NavItem } from "reactstrap";
import { UserConsumer } from '../contexts/UserContext';
import AuthService from "../services/authService";
import { FaSignOutAlt } from "react-icons/fa";

class Header extends Component {
  handleLogout = (setUser, navigate) => {
    AuthService.logout();
    setUser(null);
    navigate('/login');
  };

  render() {
    return (
      <UserConsumer>
        {({ user, setUser }) => (
          <Navbar
            color="dark"
            dark
          >
            <NavbarBrand xs="auto" href="/main" expand="xs" style={{ display: 'flex', alignItems: 'center', width: '250px' }}>
              <strong style={{ fontSize: '1.66rem' }}>SIM IQ</strong>&nbsp;-
              <img
                alt="logo"
                src="../img/vioptiq.png"
                style={{
                  height: 32,
                  paddingLeft: 5
                }}
              />

            </NavbarBrand>
            <Nav className="ml-auto" navbar>
              {user ? (
                <>
                  <NavItem className="d-flex align-items-center text-white px-3">
                    <span>
                      Welcome, {user.username}
                      {user.organization && (
                        <>
                          {' '}
                          (
                          <Link to="/organization" className="text-white text-decoration-underline">
                            {user.organization}
                          </Link>
                          )
                        </>
                      )}
                    </span>
                    <Button
                      aria-label='Logout'
                      color="link"
                      className="text-white ms-2 p-0"
                      onClick={() => this.handleLogout(setUser, this.props.navigate)}
                    >
                      <FaSignOutAlt />
                    </Button>
                  </NavItem>
                </>
              ) : (
                <NavItem>
                  <Link className="text-white" to="/login">Login</Link>
                </NavItem>
              )}
            </Nav>
          </Navbar>
        )}
      </UserConsumer>
    );
  }
}

const HeaderWithNavigate = (props) => (
  <Header {...props} navigate={useNavigate()} />
);

export default HeaderWithNavigate;